import React, {useState} from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {CustomDots} from "../../carousal/CustomDots"
import section02Styles from "../section02/section02.module.css"

export const Section09 = () => {
	const [currentSlide, setCurrentSlide] = useState(0)

	const products = [
		{
			title: "Mathieu, French",
			description:
				"‘I was amazed by the accuracy of key dates and years he pinpointed and his insights into my character and relationships. Although I can’t yet confirm his future predictions, they seemed logical given my background. If you’re a thoughtful person, I recommend trying Bazi—it offers valuable perspectives on shaping your future, though it’s wise to maintain some objectivity.’",
		},
	]

	const settings = {
		speed: 500,
		infinite: false,
		slidesToShow: 2,
		slidesToScroll: 1,
		initialSlide: 0,
		afterChange: setCurrentSlide,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 360,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	}
	return (
		<section
			id="6"
			style={{
				padding: "4rem 0",
				position: "relative",
			}}
		>
			<Slider {...settings}>
				{products?.map((item, key) => (
					<div
						key={key}
						className={section02Styles.section02__content}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								padding: "1.2rem",
								backgroundColor: "#fff",
								textAlign: "center",
							}}
						>
							<p
								style={{
									fontSize: "1.2rem",
									marginBottom: "1rem",
									color: "#000",
								}}
							>
								{item.description}
							</p>
							<h2>{item.title}</h2>
						</div>
					</div>
				))}
			</Slider>
			<CustomDots
				totalDots={products}
				dotLength={"90%"}
				currentSlide={currentSlide}
				setCurrentSlide={setCurrentSlide}
			/>
		</section>
	)
}
